import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { DemoBadge } from "@/components/DemoBadge";
import Landing from "@/pages/Landing";
import Founding from "@/pages/Founding";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Policy from "@/pages/Policy";
import Dashboard from "@/pages/Dashboard";
import ListingDetail from "@/pages/ListingDetail";
import BatchReview from "@/pages/BatchReview";
import Proof from "@/pages/Proof";
import Settings from "@/pages/Settings";
import Admin from "@/pages/Admin";
import Unsubscribe from "@/pages/Unsubscribe";
import ContentHub from "@/pages/ContentHub";
import ArticlePage from "@/pages/ArticlePage";
import About from "@/pages/About";
import NotFound from "@/pages/NotFound";
import HtmlSitemap from "@/pages/HtmlSitemap";
import ToolsHub from "@/pages/ToolsHub";
import ToolPage from "@/pages/ToolPage";
import { RouteMeta } from "@/seo/RouteMeta";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div data-testid="auth-loading" className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export const AppTree = () => (
  <AuthProvider>
    <RouteMeta />
    <DemoBadge />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/founding" element={<Founding />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/policies/:slug" element={<Policy />} />
      <Route path="/blog" element={<ContentHub type="guide" />} />
      <Route path="/blog/page/:page" element={<ContentHub type="guide" />} />
      <Route path="/blog/:slug" element={<ArticlePage kind="blog" />} />
      <Route path="/etsy-tags" element={<ContentHub type="tags" />} />
      <Route path="/etsy-tags/page/:page" element={<ContentHub type="tags" />} />
      <Route path="/etsy-tags/:slug" element={<ArticlePage kind="etsy-tags" />} />
      <Route path="/about" element={<About />} />
      <Route path="/sitemap" element={<HtmlSitemap />} />
      <Route path="/tools" element={<ToolsHub />} />
      <Route path="/tools/:slug" element={<ToolPage />} />
      <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
      <Route path="/app" element={<Protected><Dashboard /></Protected>} />
      <Route path="/app/listings/:id" element={<Protected><ListingDetail /></Protected>} />
      <Route path="/app/batch" element={<Protected><BatchReview /></Protected>} />
      <Route path="/app/proof" element={<Protected><Proof /></Protected>} />
      <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    <Toaster position="top-right" offset="88px" theme="dark" richColors />
  </AuthProvider>
);

function App() {
  return (
    <BrowserRouter>
      <AppTree />
    </BrowserRouter>
  );
}

export default App;
